import { SVGProps } from 'react';

export default function Location6(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3334)">
        <path
          d="M16.4864 2.71164C12.9292 -0.878909 7.1347 -0.905901 3.54416 2.6514C-0.0463895 6.20871 -0.0733817 12.0031 3.48392 15.5937C3.51166 15.6216 3.53955 15.6495 3.56763 15.6771L6.8481 18.7063C8.60146 20.4226 11.4029 20.43 13.1653 18.7229L16.4865 15.6538C20.0602 12.0799 20.0602 6.28558 16.4864 2.71164ZM15.0072 11.2627C15.0072 12.4114 14.076 13.3426 12.9273 13.3426H7.10349C5.95478 13.3426 5.02357 12.4114 5.02357 11.2627V8.45726C5.02357 8.05417 5.12119 7.65707 5.30809 7.29992C5.49499 6.94278 5.76562 6.63621 6.09681 6.40644L8.59271 4.67511C9.44888 4.08347 10.5819 4.08347 11.4381 4.67511L13.934 6.40644C14.2652 6.63621 14.5358 6.94278 14.7227 7.29992C14.9096 7.65707 15.0072 8.05417 15.0072 8.45726V11.2627ZM13.3433 8.45722V11.2626C13.3433 11.4923 13.157 11.6786 12.9273 11.6786H11.6793V10.0146C11.6793 9.55515 11.3068 9.18269 10.8474 9.18269H9.18342C8.72392 9.18269 8.35146 9.55519 8.35146 10.0146V11.6786H7.10349C6.87377 11.6786 6.68752 11.4923 6.68752 11.2626V8.45722C6.68748 8.32282 6.72 8.1904 6.7823 8.07131C6.8446 7.95221 6.93482 7.84998 7.04525 7.77336L9.54115 6.04203C9.68068 5.94609 9.84604 5.89473 10.0154 5.89473C10.1847 5.89473 10.3501 5.94609 10.4896 6.04203L12.9855 7.77336C13.0959 7.84997 13.1862 7.9522 13.2485 8.0713C13.3108 8.19039 13.3433 8.32281 13.3433 8.45722Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3334">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
